import { httpClient } from "@/services";

export default {
	state: {
		settingsNotifications: [],
		notificationNotifications: [],
		filtersNotifications: {},
		editNotifications: {},
	},
	mutations: {
		updateNotifications(state, { settings, items, filters }) {
			state.settingsNotifications = settings;
			state.notificationNotifications = items;
			state.filtersNotifications = filters;
		},
		updateEditNotifications(state, payload) {
			state.editNotifications = payload;
		},
	},
	actions: {

		async deleteAccountNotifications({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/notification/${ id }`);
				if (data && data.status) {
					dispatch('getAccountNotificationsList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountNotificationsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post("/info/notification/list");
				if (data) {
					commit('updateNotifications', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async onAccountNotificationsEdit({ commit, dispatch }, args ) {
			try {
				const { id } = args;
				const { data } = await httpClient.put(`/info/notification/${ id }`, args);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async onAccountNotificationsSave({ commit, dispatch }, args ) {
			dispatch("actionPreloader", true);
			try {

				const { data } = await httpClient.post("/info/notification", args);

				if ( data ) {
					commit('updateAccountSettings', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountNotificationsEditModal({ commit, dispatch }, id) {
			// dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/notification/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditNotifications', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			} finally {
				// dispatch("actionPreloader", false);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editNotifications: s => s.editNotifications,
		settingsNotifications: s => s.settingsNotifications,
		notificationNotifications: s => s.notificationNotifications,
		filtersNotifications: s => s.filtersNotifications,
	},
};
